export default __webpack_public_path__ + "static/media/Image.2652bc4e.png";